import request from "@/utils/request";

export async function calculateDeliveryFee(order) {
  const response = await request.post("/fees/delivery-fee", order);
  return response.data.data;
}